"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayMultipleCarsDetailsWidget = void 0;
var React = require("react");
var LookupWidgetBase_1 = require("../../LookupWidgetBase");
var commonFunctions_1 = require("../../../commonFunctions");
var moment = require("moment");
var services_1 = require("@falcon/services");
var DisplayMultipleCarsDetailsWidget = /** @class */ (function (_super) {
    __extends(DisplayMultipleCarsDetailsWidget, _super);
    function DisplayMultipleCarsDetailsWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        return _this;
    }
    DisplayMultipleCarsDetailsWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.renderCarDetails()));
    };
    DisplayMultipleCarsDetailsWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues("vehicleTransmission");
        this.fetchLookupValues("vehicleFuelType");
    };
    DisplayMultipleCarsDetailsWidget.prototype.renderCarDetails = function () {
        var car = this.props.interaction.vehicles[this.vehicleIndex];
        var purchaseDate = car.purchaseDate ? moment(car.purchaseDate).format("MMM YYYY") : null;
        var engineSize = (0, commonFunctions_1.getVehicleEngineSize)(car);
        return (React.createElement("div", { className: "my-3" },
            React.createElement("div", { className: "panel-preview-area mb-3" },
                React.createElement("img", { className: "icon-lg", alt: "vehicle-icon-lg", "aria-hidden": "true", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-car-icon.png") }),
                React.createElement("h2", null,
                    car.make,
                    ", ",
                    car.model),
                React.createElement("div", { className: "number-plate-preview" }, car.registrationNumber)),
            React.createElement("div", { className: "text-center font-weight-light" },
                engineSize &&
                    React.createElement("span", null,
                        engineSize,
                        "cc ",
                        React.createElement("br", null)),
                (0, commonFunctions_1.getVehicleNumberOfDoors)(car),
                " dr",
                React.createElement("br", null),
                "Manufactured in ",
                car.year,
                React.createElement("br", null),
                purchaseDate && React.createElement(React.Fragment, null,
                    "Purchased in ",
                    purchaseDate,
                    React.createElement("br", null)),
                this.resolveLookupValue("vehicleTransmission", car.transmission),
                React.createElement("br", null),
                this.resolveLookupValue("vehicleFuelType", (0, commonFunctions_1.getInteractionVehicleFuelType)(car.fuelType, car.fuelTypeFull)))));
    };
    return DisplayMultipleCarsDetailsWidget;
}(LookupWidgetBase_1.LookupWidgetBase));
exports.DisplayMultipleCarsDetailsWidget = DisplayMultipleCarsDetailsWidget;
//# sourceMappingURL=DisplayMultipleCarsDetailsWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/DisplayMultipleCarsDetailsWidget.js
// module id = 2604
// module chunks = 0